export default {
  install: function (Vue, options) {
    Vue.prototype.$handleCheckAndCallMethod = function ({service, action, allowOneOfActions, allowOneOfServices}, methodToCall) {
      if (this.$auth.isAllowed({service, action})) {
        methodToCall()
      }
    }
  }
}
